import clsx from 'clsx';
import type { SelectHTMLAttributes } from 'react';
import styles from './Input.module.css';

export function Select({
  label,
  className,
  children,
  ...rest
}: SelectHTMLAttributes<HTMLSelectElement> & { label?: string }) {
  return (
    <label className={styles.wrap}>
      {label ? <span className={styles.label}>{label}</span> : null}
      <select className={clsx(styles.select, className)} {...rest}>
        {children}
      </select>
    </label>
  );
}
